import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, Product, Media, Contact, About } from "./pages"

import ProductComp from './pages/product/components/BetaLife';
import EduPlan from './pages/product/components/EduPlan';
import Jolly from './pages/product/components/Jolly';
import AutoLoan from './pages/product/components/AutoLoan';
import SchoolFee from './pages/product/components/SchoolFee';
import PayDay from './pages/product/components/PayDay';
import "./App.css";
import BetaSubmitForm from './components/betaForm/BetaSubmitForm';
import ChildrenForm from './components/ChidrenForm/ChildrenForm';
import JollyForm from './components/jollyForm/JollyForm';
import AutoLoanForm from './components/autoLoan/AutoLoanForm';
import PaydayForm from './components/paydayForm/PaydayForm';
import SchoolFeeForm from './components/schoolfees/SchoolFeeForm';


const theme = {
  colors: {
    primary: '#000',
    secondary: '#1B20E5',
    body: "#092C4C",
    text: "#fff",
    caption: "#F2F3FF"
  },

  // font: {
  //   fontFamily: 
  // }
}

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/about" element={<About />}></Route>
            <Route path="/product" element={<Product />}>
              <Route path="/product" element={<ProductComp />}></Route>
              <Route path="edu" element={<EduPlan />}></Route>
              <Route path="jolly-jolly" element={<Jolly />}></Route>
              <Route path="auto-loan" element={<AutoLoan />}></Route>
              <Route path="payday" element={<PayDay />}></Route>
              <Route path="school-fees" element={<SchoolFee />}></Route>
              {/* <Route path="submit" element={<SubmitForm />}></Route> */}
            </Route>
            <Route path="/media" element={<Media />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
            <Route path="submit" element={<BetaSubmitForm />}></Route>
            <Route path="children" element={<ChildrenForm />}></Route>
            <Route path="jolly" element={<JollyForm />}></Route>
            <Route path="auto" element={<AutoLoanForm />}></Route>
            <Route path="pay" element={<PaydayForm />}></Route>
            <Route path="fee" element={<SchoolFeeForm />}></Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
